/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AssignTermoUsoModalAliases {
  FETCH_HPMS_TERM_USO = 'fetch-hpms-term-uso',
  HPMS_TERM_SERVICE = 'hpms-term-service',
  MODAL_ASSIGN_TERMO_USO = 'modal-assign-termo-uso',
  PANEL_0 = 'panel-0',
}
export { AssignTermoUsoModalAliases };
